/**
 * The start page states when the running version was built. Anna reads that line,
 * not a developer — so it is German, in her time zone, and it never shows a raw
 * timestamp. PROTOTYP-PLAN.md step 1 makes it the acceptance criterion.
 */
const FORMATTER = new Intl.DateTimeFormat("de-DE", {
  day: "numeric",
  month: "long",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  timeZone: "Europe/Berlin",
});

export function formatDeployTime(isoTimestamp: string): string {
  const date = new Date(isoTimestamp);
  if (Number.isNaN(date.getTime())) {
    return "unbekannt";
  }
  return `${FORMATTER.format(date)} Uhr`;
}
